import LIcon from "@components/LIcon";
import { router } from "expo-router";
import React, { useCallback } from "react";
import * as Haptics from "expo-haptics";
import { Platform } from "react-native";

const BackButton = () => {
  //Prevent flickering on back animation
  const handlePress = useCallback(() => {
    // Smooth back animation
    if (Platform.OS !== "web") {
      Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light).catch(() => {});
    }
    requestAnimationFrame(() => {
      router.back();
    });
  }, []);

  return (
    <LIcon
      name="chevron"
      rotate={90}
      size={32}
      stroke="white"
      fadeEnabled
      onPress={handlePress}
      disableLoading={true}
    />
  );
};

export default BackButton;
